export default function CommandPage() {
  return (
    <ul>
      <li>Command: </li>
    </ul>
  );
}
